import { createDevAccessToken, DEV_USER_ID } from '@/config/api/devAccessToken.js'

export function createDevAuthSession(email) {
  const normalizedEmail = email || 'dev@local.test'
  const token = createDevAccessToken(normalizedEmail)

  return {
    success: true,
    data: {
      token,
      access_token: token,
      refresh_token: '',
      user: { id: DEV_USER_ID, email: normalizedEmail, first_name: 'Dev' },
    },
  }
}
